import { Tables } from '@/lib/supabase/supabase_types_override';
import { resolveUserRoles } from '../rbac/resolveRoles';

interface PopulateUsersProps {
  users: Tables<'user'>[];
  usersWithIdOnly: Tables<'user'>[];
  userOrganizationRole?: Tables<'user_organization_role'>[];
  organizationRoleRbac?: Tables<'role_based_organization_access_control'>[];
  userProjectRole?: Tables<'user_project_role'>[];
  projectRoleRbac?: Tables<'role_based_project_access_control'>[];
}

export function populateUsersDataByTheirIds({
  users,
  usersWithIdOnly,
  userOrganizationRole,
  organizationRoleRbac,
  userProjectRole,
  projectRoleRbac,
}: PopulateUsersProps) {
  if (!users || !usersWithIdOnly) return [];

  const userMap = new Map(users.map((user) => [user.id, user]));

  return usersWithIdOnly.map((user) => {
    const fullUser = userMap.get(user.id);
    if (fullUser) {
      return resolveUserRoles({
        user: fullUser,
        orgRbac: organizationRoleRbac || [],
        userOrgRole: userOrganizationRole?.find(
          (uor) => uor.user_id === fullUser.id
        ),
        projectRbac: projectRoleRbac || [],
        userProjectRole: userProjectRole?.find(
          (upr) => upr.user_id === fullUser.id
        ),
      });
    }
  }).filter(user=> user !== undefined)
}
